export default __webpack_public_path__ + "static/media/maestro.48330d3a.svg";